/**
 * @generated SignedSource<<e0349b5dacc2f41ff7079cf708bbd456>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type moduleRatingDetailsTable_Refetch$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  nodeRef: string;
  oneKeyId?: string | null | undefined;
};
export type moduleRatingDetailsTable_Refetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"moduleRatingDetailsTable_RefetchableQueryFragment">;
};
export type moduleRatingDetailsTable_Refetch = {
  response: moduleRatingDetailsTable_Refetch$data;
  variables: moduleRatingDetailsTable_Refetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodeRef"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "oneKeyId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "nodeRef",
    "variableName": "nodeRef"
  },
  {
    "kind": "Variable",
    "name": "oneKeyId",
    "variableName": "oneKeyId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "moduleRatingDetailsTable_Refetch",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "moduleRatingDetailsTable_RefetchableQueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "moduleRatingDetailsTable_Refetch",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ModuleRatingAdminSchema",
            "kind": "LinkedField",
            "name": "ModuleRating",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "ModuleRatingTypesConnection",
                "kind": "LinkedField",
                "name": "ModuleRating",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ModuleRatingTypesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ModuleRating",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LearnOpportunityV2",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "structureDefinition",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "title",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "oneKeyId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v1/*: any*/),
                "filters": [
                  "nodeRef",
                  "oneKeyId"
                ],
                "handle": "connection",
                "key": "moduleRatingsTable_ModuleRating",
                "kind": "LinkedHandle",
                "name": "ModuleRating"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0de9b580f1cb27ba9f51376ff1086221",
    "id": null,
    "metadata": {},
    "name": "moduleRatingDetailsTable_Refetch",
    "operationKind": "query",
    "text": "query moduleRatingDetailsTable_Refetch(\n  $after: String\n  $first: Int\n  $nodeRef: ID!\n  $oneKeyId: String\n) {\n  ...moduleRatingDetailsTable_RefetchableQueryFragment_3aZcjv\n}\n\nfragment moduleRatingDetailsTable_ModuleRatingInlineFragment on ModuleRating {\n  node {\n    id\n    structureDefinition {\n      __typename\n      title\n    }\n  }\n  user {\n    id\n    name\n  }\n  value\n  message\n  oneKeyId\n  createdAt\n}\n\nfragment moduleRatingDetailsTable_RefetchableQueryFragment_3aZcjv on Query {\n  Admin {\n    ModuleRating {\n      ModuleRating(first: $first, after: $after, nodeRef: $nodeRef, oneKeyId: $oneKeyId) {\n        edges {\n          node {\n            ...moduleRatingDetailsTable_ModuleRatingInlineFragment\n            id\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c929c2bac1eae1cb5a6e2e98d2563aa9";

export default node;
